/* Memento corp - spinnable globe for the installations map on phones.
 *
 * The flat map has to be 2000px wide before the pins separate, which on a
 * phone means a long sideways scroll through a lot of empty ocean. A globe
 * puts the same pins on something you can spin with a thumb, and it is square
 * rather than a metre of horizontal canvas.
 *
 * It drives itself entirely from the markup the hot-spots section already
 * renders: pin positions come out of the CSS custom properties the template
 * writes, and the card content is cloned from each pin's existing popover. So
 * everything stays editable in the theme editor in exactly one place, and if
 * this script never runs the original scrolling map is still there.
 */
(function () {
  'use strict';

  var RINGS = [[75.5,"00000010001111111000000000000000000000"],[72.9,"00000000000100011111000000000000011100000000"],[70.3,"000000001111011000111100000000000001011111110100000"],[67.7,"000110000001010111001111100000001000000111111111111111000"],[65.1,"001111111110111110110011110000000011111111110111111111111111111"],[62.5,"110111111111111111101110111100110000111111111111111111111111111111111"],[59.9,"000111111111111111000100000110000000001110111111111111111111111111111110110"],[57.3,"000011100111111111100001100000000000000000111001111111111111111111111111111000000"],[54.7,"000000100001111111111000011110000000000000100010011111111111111111111111111110000110000"],[52.1,"00000000000001111111111110111111000000000000110111111111111111111111111111111111111000100000"],[49.5,"0000000000000011111111111111111110000000000000011111111111111111111111111111111111111100000000000"],[46.9,"000000000000000011111111111111111011000000000000001111111111111111111111111111111111111111110000000000"],[44.3,"00000000000000000111111111111111110001000000000000000111111111110111011111111111111111111111111000000000000"],[41.7,"0000000000000000011111111111111111110000000000000000010111111111101011101111111111111111111111111110100000000000"],[39.1,"00000000000000000011111111111111111100000000000000000001110000111111111111011111111111111111111111110001000000000000"],[36.5,"0000000000000000000111111111111111100000000000000000000001110000000100111111101111111111111111111111001100010000000000000"],[33.9,"00000000000000000000011111111111111110000000000000000000000000111111000000011111111111111111111111111111001100110000000000000"],[31.3,"00000000000000000000001111111111111100000000000000000000000001111111000000000111111111111111111111111111111000010000000000000000"],[28.7,"000000000000000000000001111111111111100000000000000000000000001111111111111111111111111111111111111111111111111000100000000000000000"],[26.1,"000000000000000000000000011111100000010000000000000000000000000111111111111111110111110111111111111111111111111110000000000000000000000"],[23.5,"000000000000000000000000001111110000000000000000000000000000000111111111111111111101111110000011111111111111111111010000000000000000000000"],[20.9,"00000000000000000000000000000111000001100000000000000000000000011111111111111111111101111111100001111111111111111110100000000000000000000000"],[18.3,"0000000000000000000000000000011111111000111100000000000000000000111111111111111111111101111111000000111111011111111000000000000000000000000000"],[15.7,"000000000000000000000000000000000111000000000000000000000000000000111111111111111111111001111100000001111000001111100000100000000000000000000000"],[13.1,"00000000000000000000000000000000000111100000000000000000000000000011111111111111111111111101100000000001110000000111100000100000000000000000000000"],[10.5,"000000000000000000000000000000000000001100000000000000000000000000011111111111111111111111100000000000001100000000101100000000000000000000000000000"],[7.9,"00000000000000000000000000000000000000010001011110000000000000000000111111111111111111111111111000000000001000000001001000000100000000000000000000000"],[5.3,"00000000000000000000000000000000000000000011111111110000000000000000011111111111111111111111111000000000000100000001110000110010000000000000000000000"],[2.7,"000000000000000000000000000000000000000000111111111111000000000000000000000000011111111111111110000000000000000000010100001100000000000000000000000000"],[0.1,"000000000000000000000000000000000000000000111111111111100000000000000000000000011111111111111000000000000000000000000100111110110000000000000000000000"],[-2.5,"000000000000000000000000000000000000000001111111111111110000000000000000000000111111111111111000000000000000000000000100011101000010000000000000000000"],[-5.1,"00000000000000000000000000000000000000000111111111111111111100000000000000000011111111111110000000000000000000000000011001101111110111100100000000000"],[-7.7,"00000000000000000000000000000000000000000011111111111111111110000000000000000000111111111110000000000000000000000000001110000000000011110000000000000"],[-10.3,"0000000000000000000000000000000000000000001111111111111111110000000000000000000111111111111000000000000000000000000000000001000000000011000110000000"],[-12.9,"00000000000000000000000000000000000000000011111111111111110000000000000000000011111111111100000000000000000000000000000000000001001000000000000000"],[-15.5,"0000000000000000000000000000000000000000001111111111111110000000000000000000011111111111100110000000000000000000000000000000111000100000000000000"],[-18.1,"00000000000000000000000000000000000000000001111111111111000000000000000000001111111111100110000000000000000000000000000011111111110000000000000"],[-20.7,"00000000000000000000000000000000000000000011111111111100000000000000000000011111111100011000000000000000000000000001111111111111000000000000"],[-23.3,"000000000000000000000000000000000000000000111111111110000000000000000000001111111110011100000000000000000000000001111111111111100000000000"],[-25.9,"000000000000000000000000000000000000000001111111110000000000000000000000011111111000110000000000000000000000001111111111111110000000000"],[-28.5,"000000000000000000000000000000000000000011111111000000000000000000000001111111100000000000000000000000000000111111111111110000000000"],[-31.1,"00000000000000000000000000000000000000111111110000000000000000000000000111100000000000000000000000000000011111111111110000000000"],[-33.7,"00000000000000000000000000000000000000111111000000000000000000000000011100000000000000000000000000000011110001011110000000000"],[-36.3,"0000000000000000000000000000000000001111110000000000000000000000000000000000000000000000000000000000000000011110000000000"],[-38.9,"000000000000000000000000000000000011111100000000000000000000000000000000000000000000000000000000000000001110000000010"],[-41.5,"0000000000000000000000000000000001110000000000000000000000000000000000000000000000000000000000000000011000000110"],[-44.1,"000000000000000000000000000000001100000000000000000000000000000000000000000000000000000000000000000000001100"],[-46.7,"0000000000000000000000000000001110000000000000000000000000000000000000000000000000000000000000000000000"],[-49.3,"00000000000000000000000000001110000000000000000000000000000000000000000000000000000000000000000000"],[-51.9,"000000000000000000000000000110000000000000000000000000000000000000000000000000000000000000000"],[-54.5,"000000000000000000000000001100000000000000000000000000000000000000000000000000000000000"]];

  var MOBILE = '(max-width: 699px)';
  /* The mobile pin percentages are plotted against this latitude window - the
     crop the mobile map image was made to. Longitude is the full 360. */
  var LAT_TOP = 60, LAT_BOT = -45;

  var DOT = 'rgba(150,166,182,';
  var ACCENT = '#00fca6';
  var PIN = '#ffffff';   /* pins read white; the accent marks the open one */
  var INK = '#0a1017';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function unit(latDeg, lonDeg) {
    var la = latDeg * Math.PI / 180, lo = lonDeg * Math.PI / 180;
    var c = Math.cos(la);
    return { x: c * Math.sin(lo), y: Math.sin(la), z: c * Math.cos(lo) };
  }

  var LAND = (function () {
    var out = [];
    for (var r = 0; r < RINGS.length; r++) {
      var lat = RINGS[r][0], bits = RINGS[r][1], n = bits.length;
      for (var i = 0; i < n; i++) {
        if (bits.charCodeAt(i) === 49) {
          out.push(unit(lat, -180 + (i + 0.5) * 360 / n));
        }
      }
    }
    return out;
  })();

  function readPins(section) {
    var pins = [];
    section.querySelectorAll('.hot-spot').forEach(function (el) {
      var cs = getComputedStyle(el);
      var h = parseFloat(cs.getPropertyValue('--hot-spot-horizontal-position'));
      var v = parseFloat(cs.getPropertyValue('--hot-spot-vertical-position'));
      if (!isFinite(h) || !isFinite(v)) return;
      var prose = el.querySelector('.hot-spot-popover .prose');
      var title = el.querySelector('.hot-spot-popover .h6');
      pins.push({
        p: unit(LAT_TOP - v / 100 * (LAT_TOP - LAT_BOT), h / 100 * 360 - 180),
        html: prose ? prose.innerHTML : '',
        name: title ? title.textContent.trim() : ''
      });
    });
    return pins;
  }

  function build(section) {
    var pins = readPins(section);
    if (pins.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'corp-globe';
    var canvas = document.createElement('canvas');
    canvas.className = 'corp-globe__canvas';
    canvas.setAttribute('role', 'application');
    canvas.setAttribute('aria-label', 'Spinnable globe of Memento installations. A list of the same places follows.');
    var hint = document.createElement('p');
    hint.className = 'corp-globe__hint';
    hint.textContent = 'Drag to spin · tap a pin';
    var card = document.createElement('div');
    card.className = 'corp-globe__card';
    card.hidden = true;
    wrap.appendChild(canvas);
    wrap.appendChild(hint);
    wrap.appendChild(card);

    var media = section.querySelector('.content-over-media');
    if (!media) return;
    media.parentNode.insertBefore(wrap, media);
    section.classList.add('corp-globe-on');

    var ctx = canvas.getContext('2d');
    var size = 0, dpr = 1, R = 0, cx = 0, cy = 0;

    function resize() {
      var w = Math.min(wrap.clientWidth, 460);
      if (!w) return;
      size = w;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(size * dpr);
      canvas.height = Math.round(size * dpr);
      canvas.style.width = size + 'px';
      canvas.style.height = size + 'px';
      R = size * 0.44 * dpr;
      cx = canvas.width / 2;
      cy = canvas.height / 2;
    }

    /* Opens on Europe, which is where the pins cluster, rather than on ocean. */
    var yaw = -0.15, pitch = 0.32, vYaw = 0, vPitch = 0;
    var dragging = false, moved = 0, lastX = 0, lastY = 0, idle = 0;
    var screenPins = [];

    function rotate(p) {
      var cy_ = Math.cos(yaw), sy = Math.sin(yaw);
      var x = p.x * cy_ + p.z * sy;
      var z = -p.x * sy + p.z * cy_;
      var cp = Math.cos(pitch), sp = Math.sin(pitch);
      var y = p.y * cp - z * sp;
      z = p.y * sp + z * cp;
      return { x: x, y: y, z: z };
    }

    function draw() {
      if (!size) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      /* the sphere itself, a touch lighter than the section behind it */
      ctx.beginPath();
      ctx.arc(cx, cy, R, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,.035)';
      ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,.10)';
      ctx.lineWidth = 1 * dpr;
      ctx.stroke();

      var dotR = Math.max(1, 1.15 * dpr);
      for (var i = 0; i < LAND.length; i++) {
        var q = rotate(LAND[i]);
        if (q.z <= 0.02) continue;
        ctx.globalAlpha = 0.22 + 0.78 * q.z;
        ctx.beginPath();
        ctx.arc(cx + q.x * R, cy - q.y * R, dotR, 0, Math.PI * 2);
        ctx.fillStyle = DOT + '1)';
        ctx.fill();
      }
      ctx.globalAlpha = 1;

      screenPins = [];
      for (var j = 0; j < pins.length; j++) {
        var r = rotate(pins[j].p);
        if (r.z <= 0.06) continue;
        var px = cx + r.x * R, py = cy - r.y * R;
        var s = (0.72 + 0.28 * r.z) * dpr;
        screenPins.push({ i: j, x: px, y: py, r: 13 * s });

        var isOpen = (j === active);
        var pinColour = isOpen ? ACCENT : PIN;

        ctx.globalAlpha = (isOpen ? 0.30 : 0.18) + 0.30 * r.z;
        ctx.beginPath();
        ctx.arc(px, py, 13 * s, 0, Math.PI * 2);
        ctx.fillStyle = pinColour;
        ctx.fill();

        ctx.globalAlpha = 0.55 + 0.45 * r.z;
        ctx.beginPath();
        ctx.arc(px, py, 7 * s, 0, Math.PI * 2);
        ctx.fillStyle = pinColour;
        ctx.fill();

        ctx.globalAlpha = 1;
        ctx.strokeStyle = INK;
        ctx.lineWidth = 1.6 * s;
        ctx.beginPath();
        ctx.moveTo(px - 3.2 * s, py); ctx.lineTo(px + 3.2 * s, py);
        ctx.moveTo(px, py - 3.2 * s); ctx.lineTo(px, py + 3.2 * s);
        ctx.stroke();
      }
    }

    function tick() {
      if (!dragging) {
        if (Math.abs(vYaw) > 0.00004 || Math.abs(vPitch) > 0.00004) {
          yaw += vYaw; pitch += vPitch;
          vYaw *= 0.94; vPitch *= 0.94;
          idle = 0;
        } else if (!reduced && ++idle > 90) {
          yaw += 0.0016;
        }
        pitch = Math.max(-0.55, Math.min(0.75, pitch));
      }
      draw();
      requestAnimationFrame(tick);
    }

    var active = -1;

    function openCard(i) {
      active = i;
      card.innerHTML = '<button type="button" class="corp-globe__close" aria-label="Close">&times;</button>' + pins[i].html;
      card.hidden = false;
      card.classList.remove('is-in');
      /* next frame so the transition actually runs */
      requestAnimationFrame(function () { card.classList.add('is-in'); });
      card.querySelector('.corp-globe__close').addEventListener('click', function () {
        card.hidden = true;
        active = -1;
      });
      /* the card sits under the globe, which is not obvious on a phone -
         bring it into view so the tap visibly produces something */
      if (card.scrollIntoView) card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    canvas.addEventListener('pointerdown', function (e) {
      dragging = true; moved = 0; idle = 0;
      lastX = e.clientX; lastY = e.clientY;
      vYaw = vPitch = 0;
      canvas.setPointerCapture(e.pointerId);
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY;
      moved += Math.abs(dx) + Math.abs(dy);
      vYaw = dx * 0.0055; vPitch = dy * 0.0045;
      yaw += vYaw; pitch += vPitch;
      pitch = Math.max(-0.55, Math.min(0.75, pitch));
      e.preventDefault();
    });
    function release(e) {
      if (!dragging) return;
      dragging = false;
      if (moved < 8) {
        /* a tap, not a drag - find the pin under the finger */
        var rect = canvas.getBoundingClientRect();
        var px = (e.clientX - rect.left) * dpr, py = (e.clientY - rect.top) * dpr;
        var best = null, bestD = 26 * dpr;
        for (var k = 0; k < screenPins.length; k++) {
          var sp = screenPins[k];
          var d = Math.hypot(sp.x - px, sp.y - py);
          if (d < bestD) { bestD = d; best = sp.i; }
        }
        vYaw = vPitch = 0;
        if (best !== null) openCard(best);
      }
    }
    canvas.addEventListener('pointerup', release);
    canvas.addEventListener('pointercancel', function () { dragging = false; });

    /* keyboard: the pin list under the globe stays reachable, but let arrows
       spin it too for anyone driving without a pointer */
    canvas.tabIndex = 0;
    canvas.addEventListener('keydown', function (e) {
      var step = 0.14;
      if (e.key === 'ArrowLeft') { yaw -= step; idle = 0; e.preventDefault(); }
      if (e.key === 'ArrowRight') { yaw += step; idle = 0; e.preventDefault(); }
      if (e.key === 'ArrowUp') { pitch = Math.max(-0.55, pitch - step); e.preventDefault(); }
      if (e.key === 'ArrowDown') { pitch = Math.min(0.75, pitch + step); e.preventDefault(); }
    });

    resize();
    window.addEventListener('resize', resize);
    /* paint once up front so the globe is there even if the tab is throttled
       and rAF is slow to start */
    draw();
    window.addEventListener('resize', draw);
    requestAnimationFrame(tick);
  }

  function init() {
    if (!window.matchMedia(MOBILE).matches) return;
    document.querySelectorAll('.shopify-section--hot-spots').forEach(function (s) {
      if (!s.classList.contains('corp-globe-on')) build(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
